/**
 * Cancellable async run helper for useEffect loaders.
 * Behavior-preserving equivalent of `let cancelled = false` + cleanup.
 */

export interface CancellableRun {
  /** True after cancel() — skip state updates. */
  isCancelled: () => boolean;
  cancel: () => void;
}

export function beginCancellableRun(): CancellableRun {
  let cancelled = false;
  return {
    isCancelled: () => cancelled,
    cancel: () => {
      cancelled = true;
    },
  };
}
